angular.module('core').filter('classDuration', [
	function() {
		return function(item) {
			return item.starting_time + ' - ' + item.ending_time;
		};
	}
]);
